import { Component, OnDestroy, OnInit } from '@angular/core';
import { TableLazyLoadEvent } from 'primeng/table';
import { Subject, Subscription, catchError, combineLatest, debounceTime, of, switchMap } from 'rxjs';
import { FiltrosFluxoCaixaService } from '../../../../filters/filtros-fluxocaixa.service';
import { FluxocaixaService } from '../../../../services/fluxocaixa.service';
import { CustoCalculado } from '../../../../types/CustoCalculado.type';
import { Page } from '../../../../types/Page.type';

@Component({
  selector: 'app-fluxocaixacustoscalculados',
  templateUrl: './fluxocaixacustoscalculados.component.html',
  styleUrl: './fluxocaixacustoscalculados.component.css',
})
export class FluxocaixacustoscalculadosComponent implements OnInit, OnDestroy {
  custos: CustoCalculado[] = [];
  totalRecords: number = 0;
  loading: boolean = false;

  dataInicio: string = '';
  dataFim: string = '';
  instancia: string = '';

  first: number = 0;
  rows: number = 100;
  sortField: string = 'empresa';
  sortDirection: string = 'asc';

  private readonly carregar = new Subject<void>();
  private readonly subscriptions = new Subscription();

  constructor(
    private fluxocaixaService: FluxocaixaService,
    private filterService: FiltrosFluxoCaixaService
  ) {}

  ngOnInit() {
    // debounceTime(0) agrupa o disparo inicial da tabela com o dos filtros em uma única requisição
    this.subscriptions.add(
      this.carregar
        .pipe(
          debounceTime(0),
          switchMap(() => this.buscarPagina())
        )
        .subscribe((pagina) => {
          this.custos = pagina?.content ?? [];
          this.totalRecords = pagina?.page?.totalElements ?? pagina?.totalElements ?? 0;
          this.loading = false;
        })
    );

    this.getFiltros();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getFiltros(){
    this.subscriptions.add(
      combineLatest([
        this.filterService.currentInstancia,
        this.filterService.currentDataInicio,
        this.filterService.currentDataFim,
      ]).subscribe(([instancia, inicio, fim]) => {
        this.instancia = instancia;
        this.dataInicio = inicio;
        this.dataFim = fim;
        this.first = 0;
        this.carregar.next();
      })
    );
  }

  // A tabela é lazy: paginação e ordenação são feitas no banco, então o total exibido é o total filtrado.
  loadCustos(event: TableLazyLoadEvent) {
    this.first = event.first ?? 0;
    this.rows = event.rows || this.rows;

    const campo = Array.isArray(event.sortField) ? event.sortField[0] : event.sortField;
    this.sortField = campo || 'empresa';
    this.sortDirection = event.sortOrder === -1 ? 'desc' : 'asc';

    this.carregar.next();
  }

  private buscarPagina() {
    if (this.instancia == '' || this.dataInicio == '' || this.dataFim == '') {
      this.loading = false;
      return of<Page<CustoCalculado> | null>(null);
    }

    this.loading = true;

    return this.fluxocaixaService
      .getCustosCalculados(
        Math.floor(this.first / this.rows),
        this.rows,
        this.sortField,
        this.sortDirection,
        this.instancia,
        this.dataInicio,
        this.dataFim
      )
      .pipe(
        catchError((error) => {
          console.error('Erro ao carregar custos calculados:', error);
          return of<Page<CustoCalculado> | null>(null);
        })
      );
  }
}
